import type { SegmentDetailApi, SegmentListItemApi } from '../types/segments-api.types';
import type { Segment, SegmentsPagingResult } from '../types/segments.types';
import { normalizeRuleGroupFromApi } from './segment-rule-tree';

type SegmentPageInfo = {
  limit?: number;
  offset?: number;
  total?: number;
  hasNext?: boolean;
  hasPrev?: boolean;
};

export const mapSegmentApiToSegment = (item: SegmentListItemApi | SegmentDetailApi): Segment => ({
  itemId: item.itemId,
  name: item.name,
  description: item.description ?? null,
  matchCount: item.matchCount ?? null,
  matchCountAt: item.matchCountAt ?? null,
  createdDate: item.createdDate ?? null,
  lastUpdatedDate: item.lastUpdatedDate ?? null,
  ...('rules' in item && item.rules
    ? { rules: normalizeRuleGroupFromApi(item.rules) }
    : {}),
});

export const mapSegmentItems = (items: SegmentListItemApi[]): Segment[] =>
  items.map(mapSegmentApiToSegment);

export const toSegmentsPagingResult = (
  items: Segment[],
  pageNo: number,
  pageSize: number,
  pageInfo: SegmentPageInfo
): SegmentsPagingResult => {
  const resolvedPageSize = pageInfo.limit ?? pageSize;
  const totalCount = pageInfo.total ?? items.length;
  const totalPages = resolvedPageSize > 0 ? Math.ceil(totalCount / resolvedPageSize) : 0;

  return {
    items,
    totalCount,
    pageNo,
    pageSize: resolvedPageSize,
    totalPages,
    hasNextPage: pageInfo.hasNext ?? pageNo < totalPages,
    hasPreviousPage: pageInfo.hasPrev ?? pageNo > 1,
  };
};
